
import CatalogSearchSection from "../../common/catalog/CatalogSearchSection";

export default function SearchSection({ initQuery, onSearch }) {
	return (
		<CatalogSearchSection
			title="چالشت رو جستجو کن"
			placeholder="چالش"
			initQuery={initQuery}
			onSearch={onSearch}
		/>
	);
}
